import { jsx as o } from "react/jsx-runtime";
import { p as a } from "../../index-B0ARwqly.mjs";
import "react";
function i({ content: r, classname: t }) {
  return /* @__PURE__ */ o("tab-content", { class: t, children: typeof r == "string" ? a(r) : r });
}
export {
  i as TabContent,
  i as default
};
